import { Component, OnInit } from '@angular/core';
import {TitleService} from "../../services/title.service";

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

  constructor(titleService: TitleService) {
    titleService.setTitle("Benutzerverwaltung")
  }

  ngOnInit(): void {
  }

}
